"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var lodash_set_1 = __importDefault(require("lodash.set"));
var react_1 = __importStar(require("react"));
function explodeFlatErrors(errors) {
    var newErrors = {};
    var keys = Object.keys(errors);
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        lodash_set_1.default(newErrors, key, errors[key]);
    }
    return newErrors;
}
exports.explodeFlatErrors = explodeFlatErrors;
exports.useFormContext = formik_1.useFormikContext;
function FormProvider(props) {
    var _a = props.validateOnBlur, validateOnBlur = _a === void 0 ? false : _a, _b = props.validateOnChange, validateOnChange = _b === void 0 ? false : _b, initialErrors = props.initialErrors, rest = __rest(props, ["validateOnBlur", "validateOnChange", "initialErrors"]);
    var _c = react_1.useState(explodeFlatErrors(initialErrors || {})), errors = _c[0], setErrors = _c[1];
    react_1.useEffect(function () { return setErrors(explodeFlatErrors(initialErrors || {})); }, [initialErrors]);
    return (react_1.default.createElement(formik_1.Formik, __assign({ validateOnChange: validateOnChange, validateOnBlur: validateOnBlur, initialErrors: errors }, rest)));
}
exports.default = FormProvider;
//# sourceMappingURL=index.js.map